import React from 'react';
import posthog from 'posthog-js';
import { PostHogProvider as PostHogProviderBase } from 'posthog-js/react';

import { AnalyticsContext } from './AnalyticsContext.tsx';
import { useInternalAnalytics } from './useInternalAnalytics.ts';

type PostHogProviderProps = {
  isEnabled: boolean;
  children: React.ReactNode;
};

const PostHogProvider = ({ isEnabled, children }: PostHogProviderProps) => {
  if (!isEnabled) {
    return children;
  }

  return <PostHogProviderBase client={posthog}>{children}</PostHogProviderBase>;
};

type AnalyticsProviderProps = {
  children: React.ReactNode;
};

export const AnalyticsProvider = ({ children }: AnalyticsProviderProps) => {
  const analytics = useInternalAnalytics();

  return (
    <AnalyticsContext.Provider value={analytics}>
      <PostHogProvider isEnabled={analytics.isEnabled}>{children}</PostHogProvider>
    </AnalyticsContext.Provider>
  );
};
